import {AfterViewInit, Component, input, signal} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {MatButton} from "@angular/material/button";
import {LoaderService} from "./services/loader.service";
import {PositionDirective} from "./directives/position.directive";
import {AmadWebNetworkService} from "./network/amad-web-network.service";
import {DeviceDetectorService} from "ngx-device-detector";
import {TokenRequestModel} from "./entities/token-request";
import {ViewComponent} from "./ui/view/view.component";
import {ComponentEntity} from "./entities/component-entity";
import {CacheService} from "./services/cache.service";
import {INFORMATION_PERSONAL, ROUTER_VIEW, TWELVE} from "./commons/constans";
import {environment} from "../environments/environment";
import {ApplicantProject} from "./entities/projects.entities";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MatButton, PositionDirective, ViewComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements AfterViewInit {
  title = 'amad-web-client';
  geolocation?:GeolocationPosition=undefined
  tokenRequestModel= input<TokenRequestModel>({
    android_version:"",
    id_application:environment.idApplication,
    model:"",
    phone_number:"",
    phone_id:"",
    other_information:{
      lat:0,
      long:0,
      origin:"",
      state:"",
      telMarcado:""
    }
  })
  constructor(private loaderService: LoaderService,
              private amadWebNetworkService:AmadWebNetworkService,
              private deviceService: DeviceDetectorService,
              private cacheService:CacheService,
              private analytics:AmadWebNetworkService,
              private router: Router) {





  }

  ngAfterViewInit(): void {
    this.loaderService.show()

    navigator.geolocation.getCurrentPosition(position =>
      {
        this.geolocation = position
        this.loadApplication()
      }, err => {
        this.loadApplication()

      }
    )
    }

  private sendInformation(applicantProject:ApplicantProject) {
    let request = this.tokenRequestModel()!

    request.android_version = `${this.deviceService.browser}/${this.deviceService.os}`
    request.id_application = environment.idApplication
    request.model = this.deviceService.device
    request.other_information.telMarcado = "";
    request.other_information.state = "";
    request.other_information.lat = this.geolocation?.coords.latitude ?? 0;
    request.other_information.long = this.geolocation?.coords.longitude ?? 0;
    this.analytics.load(request).subscribe(() => {

      this.analytics.sendClicks({
        id_action:"480",
        other_information:"opened"

      }).subscribe(value => {

        let mainView =
          applicantProject.views.find(view => {
            return view.mainView;
          })
        this.router.navigate([`/${ROUTER_VIEW}`, mainView?.id ?? "" ]); // Navega con parámetros
      })
      this.loaderService.hide()
    })
  }
  private loadConfiguration(){
    this.amadWebNetworkService.getConfig(environment.idApplication)
      .subscribe(value => {
      this.loaderService.hide()
        this.cacheService.set(CacheService.APP_INFORMATION,value,TWELVE)
        this.cacheService.set(CacheService.VIEWS,value.views,TWELVE)

        if(value.personalInformation.active ){
          this.router.navigate([`/${INFORMATION_PERSONAL}` ]); // Navega con parámetros
        }else {
        this.sendInformation(value)
          }
    })
  }
  private loadApplication(){
    this.loadConfiguration()
  }

}
